import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./pages/Home";
import AiAgent from "./pages/AiAgent";
import Landing from "./pages/Landing";
import VoiceMail from "./pages/VoiceMail";
import ErrorLogs from "./pages/ErrorLogs";
import InvitePage from "./pages/InvitePage";
import TeamMembers from "./pages/TeamMembers";
import RequestPage from "./pages/NumberAccess";
import Settings from "./pages/Settings/Settings";
import LoginScreen from "./pages/Auth/LoginScreen";
import CallDashboard from "./pages/CallDashboard";
import Reports from "./pages/Reports";
import CompanyProfile from "./pages/CompanyProfile";
import UserExtensions from "./pages/UserExtensions";
import SignupScreen from "./pages/Auth/SignupScreen";
import ProfilePage from "./pages/Settings/ProfilePage";
import PageNotFound from "./pages/Errors/PageNotFound";
import ExtensionAllocation from "./pages/ExtensionAllocation";
import UnauthorizedPage from "./pages/Errors/UnauthorizedPage";

import ToastTheme from "./themes/ToastTheme";
import CallScreen from "./components/Dialpad/CallScreen";
import PrivateRoute from "./auth/PrivateRoute";
import DashboardLayout from "./layouts/DashboardLayout";

import "./App.css";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import { setupMessageListener } from "./services/firebase";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute element={<DashboardLayout />} roles={["2", "3"]} />,
    errorElement: <PageNotFound />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "call",
        element: <CallDashboard />,
      },
      {
        path: "reports",
        element: <PrivateRoute element={<Reports />} roles={["2", "3"]} />,
      },
      {
        path: "contact-us",
        element: <Home />,
      },
      {
        path: "extensions-allocation",
        element: <PrivateRoute element={<ExtensionAllocation />} roles={["2"]} />,
      },
      {
        path: "voice-mail",
        element: <PrivateRoute element={<VoiceMail />} roles={["2", "3"]} />,
      },
      {
        path: "extensions",
        element: <PrivateRoute element={<UserExtensions />} roles={["3"]} />,
      },
      {
        path: "requests",
        element: <PrivateRoute element={<RequestPage />} roles={["2"]} />,
      },
      {
        path: "invites",
        element: <PrivateRoute element={<InvitePage />} roles={["2"]} />,
      },
      {
        path: "users",
        element: <PrivateRoute element={<TeamMembers />} roles={["2"]} />,
      },
      {
        path: "ai-agent",
        element: <PrivateRoute element={<AiAgent />} roles={["2"]} />,
      },
      {
        path: "error-logs",
        element: <PrivateRoute element={<ErrorLogs />} roles={["2"]} />,
      },
      {
        path: "settings",
        element: <PrivateRoute element={<Settings />} roles={["2", "3"]} />,
      },
      {
        path: "setting-page",
        element: <Settings />,
      },
      {
        path: "company-profile",
        element: <CompanyProfile />,
      },
    ],
  },
  {
    path: "profile-page",
    element: <ProfilePage />,
  },
  {
    path: "/sign-in",
    element: <LoginScreen />,
  },
  {
    path: "/sign-up",
    element: <SignupScreen />,
  },
  {
    path: "/invite/:id",
    element: <LoginScreen />,
  },
  {
    path: "/add-company/:id",
    element: <LoginScreen />,
  },
  {
    path: "unauthorized",
    element: <UnauthorizedPage />,
  },
  {
    path: "/discover",
    element: <Landing />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/contact",
    element: <ContactUs />,
  },
  {
    path: "/loginScreen",
    element: <LoginScreen />,
  },
  {
    path: "/call-screen",
    element: <CallScreen />,
  },
]);

function App() {
  useEffect(() => {
    // Set up Firebase Cloud Messaging listener for foreground notifications
    setupMessageListener((payload) => {
      console.log("Notification received in App:", payload);
      // You can add custom handling here, such as:
      // - Updating UI state
      // - Playing a sound
      // - Showing a custom toast notification
      // - Updating a notification badge
    });
  }, []);

  return (
    <>
      <Toaster toastOptions={ToastTheme} />
      <RouterProvider router={routes} />
    </>
  );
}

export default App;
